import React, { Component } from 'react';
import Body from '../Body/Body';
import Footer from '../Footer/Footer';
import { interstitial } from '../Services/Adsense/ads';

export default class App extends Component {
  componentDidMount() {
    interstitial();
  }
  render() {
    return (
      <div className="App">
        <Body />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx